<template>
    <div class="float-left mr-1">
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
            @show="abrirModal()">
            <div slot="modal-title">
                Documento -
                <b-badge variant="warning">{{ operacaoProp }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Documento</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposDocumentos"
                            v-model="id_TipoDocumento"
                            text-field="vcDescricaoTipoDocumento"
                            value-field="idTipoDocumento">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição do Arquivo</label>
                        <b-form-textarea
							:rows="4"
                            v-model="vcDescricaoDocumento"
						></b-form-textarea>
                        <b-form-invalid-feedback>A descrição do documento é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click.stop="salvar()"
                    :disabled="this.$v.$invalid">
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

    export default {
        validations: {
            id_TipoDocumento: { required },
            vcDescricaoDocumento: { required },
            arquivo: { required }
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            },
            idPrestacaoFinal: {
                type: Number,
                default: 0
            },
            dataServicos: {
                type: Object
            },
            operacaoProp: {
                type: String,
                default: 'INSERIR'
            },
            mostrarModal: {
                type: Boolean,
                default: false
            },
            erros: {
                type: Array,
                default: () => []
            },
            documento: {
                type: Object
            }
        },

        data() {
            return {
                tiposDocumentos: [],
                id_Documento: 0,
                id_Convenio: 0,
                id_TipoDocumento: '',
                vcDescricaoDocumento: '',
                vcNomeArquivo: '',
                idPrestacaoContasFinal: 0,
                arquivo: null
            }
        },

        methods: {
            limpar(){
                this.id_Documento = 0;
                this.id_Convenio = this.convenio.idConvenio;
                this.id_TipoDocumento = '';
                this.vcDescricaoDocumento = '';
                this.vcNomeArquivo = '';
                this.idPrestacaoContasFinal = 0;
                this.arquivo = null;
            },

            preencher(){
                if(this.operacaoProp === 'INSERIR'){
                    this.id_Documento = 0;
                    this.id_Convenio = this.convenio.idConvenio;
                    this.id_TipoDocumento = '';
                    this.vcDescricaoDocumento = '';
                    this.vcNomeArquivo = '';
                    this.idPrestacaoContasFinal = this.idPrestacaoFinal;
                    this.arquivo = null;
                } else {
                    this.id_Documento = this.documento.id_Documento;
                    this.id_Convenio = this.documento.id_Convenio;
                    this.id_TipoDocumento = this.documento.id_TipoDocumento;
                    this.vcDescricaoDocumento = this.documento.vcDescricaoDocumento;
                    this.vcNomeArquivo = this.documento.vcNomeArquivo;
                    this.idPrestacaoContasFinal = this.documento.idPrestacaoContasFinal;
                    this.arquivo = null;
                }
            },

            abrirModal() {
                this.obterTiposDocumentos();
                this.preencher();
            },

            fecharModal() {
                this.limpar();
                this.$emit('fechar')
            },

            obterTiposDocumentos() {
                this.$store.dispatch('addRequest')
                this.dataServicos.obterTiposDocumentos().then(response => {
                    if (response) {
                        if (response.success) {
                            this.tiposDocumentos = response.data
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            salvar(){
                let documentoConvenioDto = {
                    idTipoDocumento: this.id_TipoDocumento,
                    idConvenio: this.convenio.idConvenio,
                    idPrestacaoContasFinal: this.idPrestacaoFinal,
                    vcDescricaoDocumento: this.vcDescricaoDocumento,
                    arquivo: this.arquivo,
                    idDocumento: this.id_Documento,
                    vcNomeArquivo: this.arquivo.name
                }
                this.$emit('salvar', documentoConvenioDto)
                this.fecharModal()
            }
        },
}
</script>
